import {inject, Injectable, signal} from '@angular/core';
import {Apollo, gql} from 'apollo-angular';
import {Mutation} from '../interfaces/generated/graphql';
import {BasicModalService} from './basic-modal.service';
import {FlexPosService} from './flex-pos.service';
import {ActivatedRoute} from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class HubspotService {

  apollo = inject(Apollo);
  basicModalService = inject(BasicModalService);
  flexPosService = inject(FlexPosService);
  activatedRoute = inject(ActivatedRoute);

  subscribeCustomerToNewsletter(vismaId: string, subscribeToNormalNewsletter: boolean, subscribeTo1To2EmailsAWeek: boolean) {
    let store = 'Ukendt butik';
    const storeParam = this.activatedRoute.snapshot.queryParams['store'];
    if (storeParam) {
      store = storeParam;
    }
    return this.apollo.mutate<Mutation>({
      mutation: gql`
        mutation hubSpotFormEvent($data: String!) {
          hubSpotFormEvent(formName: "SdkSubscribeToNewsletters", data: $data)
        }
      `,
      variables: {
        data: JSON.stringify({
          store,
          visma_id: vismaId,
          subscribeToNormalNewsletter,
          subscribeTo1To2EmailsAWeek
        })
      }
    }).toPromise().then(() => {
      this.basicModalService.showSuccessModal('Tilmelding til nyhedsbrev sendt!', 'Luk modul', () => {
        this.flexPosService.closeBrowser();
      });
    }).catch((reason) => {
      this.basicModalService.showErrorModal('Der skete en fejl under tilmelding til nyhedsbrevet');
      console.error('Error subscribing to newsletter', reason);
    });
  }
}
